// Spin JS
(function (t, e) {
  if (typeof exports == "object") module.exports = e();
  else if (typeof define == "function" && define.amd) define(e);
  else t.Spinner = e();
})(this, function () {
  "use strict";
  var t = ["webkit", "Moz", "ms", "O"],
    e = {},
    i;
  function o(t, e) {
    var i = document.createElement(t || "div"),
      o;
    for (o in e) i[o] = e[o];
    return i;
  }
  function n(t) {
    for (var e = 1, i = arguments.length; e < i; e++)
      t.appendChild(arguments[e]);
    return t;
  }
  var r = (function () {
    var t = o("style", { type: "text/css" });
    n(document.getElementsByTagName("head")[0], t);
    return t.sheet || t.styleSheet;
  })();
  function s(t, o, n, s) {
    var a = ["opacity", o, ~~(t * 100), n, s].join("-"),
      f = 0.01 + (n / s) * 100,
      l = Math.max(1 - ((1 - t) / o) * (100 - f), t),
      d = i.substring(0, i.indexOf("Animation")).toLowerCase(),
      u = (d && "-" + d + "-") || "";
    if (!e[a]) {
      r.insertRule(
        "@" +
          u +
          "keyframes " +
          a +
          "{" +
          "0%{opacity:" +
          l +
          "}" +
          f +
          "%{opacity:" +
          t +
          "}" +
          (f + 0.01) +
          "%{opacity:1}" +
          ((f + o) % 100) +
          "%{opacity:" +
          t +
          "}" +
          "100%{opacity:" +
          l +
          "}" +
          "}",
        r.cssRules.length
      );
      e[a] = 1;
    }
    return a;
  }
  function a(e, i) {
    var o = e.style,
      n,
      r;
    if (o[i] !== undefined) return i;
    i = i.charAt(0).toUpperCase() + i.slice(1);
    for (r = 0; r < t.length; r++) {
      n = t[r] + i;
      if (o[n] !== undefined) return n;
    }
  }
  function f(t, e) {
    for (var i in e) t.style[a(t, i) || i] = e[i];
    return t;
  }
  function l(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var o in i) if (t[o] === undefined) t[o] = i[o];
    }
    return t;
  }
  function d(t) {
    var e = { x: t.offsetLeft, y: t.offsetTop };
    while ((t = t.offsetParent)) (e.x += t.offsetLeft), (e.y += t.offsetTop);
    return e;
  }
  var u = {
    lines: 12,
    length: 7,
    width: 5,
    radius: 10,
    rotate: 0,
    corners: 1,
    color: "#000",
    direction: 1,
    speed: 1,
    trail: 100,
    opacity: 1 / 4,
    fps: 20,
    zIndex: 2e9,
    className: "spinner",
    top: "auto",
    left: "auto",
    position: "relative",
  };
  function p(t) {
    if (typeof this == "undefined") return new p(t);
    this.opts = l(t || {}, p.defaults, u);
  }
  p.defaults = {};
  l(p.prototype, {
    spin: function (t) {
      this.stop();
      var e = this,
        n = e.opts,
        r = (e.el = f(o(0, { className: n.className }), {
          position: n.position,
          width: 0,
          zIndex: n.zIndex,
        })),
        s = n.radius + n.length + n.width,
        a,
        l;
      if (t) {
        t.insertBefore(r, t.firstChild || null);
        l = d(t);
        a = d(r);
        f(r, {
          left:
            (n.left == "auto"
              ? l.x - a.x + (t.offsetWidth >> 1)
              : parseInt(n.left, 10) + s) + "px",
          top:
            (n.top == "auto"
              ? l.y - a.y + (t.offsetHeight >> 1)
              : parseInt(n.top, 10) + s) + "px",
        });
      }
      r.setAttribute("role", "progressbar");
      e.lines(r, e.opts);
      if (!i) {
        var u = 0,
          p = ((n.lines - 1) * (1 - n.direction)) / 2,
          c,
          h = n.fps,
          m = h / n.speed,
          y = (1 - n.opacity) / ((m * n.trail) / 100),
          g = m / n.lines;
        (function v() {
          u++;
          for (var t = 0; t < n.lines; t++) {
            c = Math.max(1 - ((u + (n.lines - t) * g) % m) * y, n.opacity);
            e.opacity(r, t * n.direction + p, c, n);
          }
          e.timeout = e.el && setTimeout(v, ~~(1e3 / h));
        })();
      }
      return e;
    },
    stop: function () {
      var t = this.el;
      if (t) {
        clearTimeout(this.timeout);
        if (t.parentNode) t.parentNode.removeChild(t);
        this.el = undefined;
      }
      return this;
    },
    lines: function (t, e) {
      var r = 0,
        a = ((e.lines - 1) * (1 - e.direction)) / 2,
        l;
      function d(t, i) {
        return f(o(), {
          position: "absolute",
          width: e.length + e.width + "px",
          height: e.width + "px",
          background: t,
          boxShadow: i,
          transformOrigin: "left",
          transform:
            "rotate(" +
            ~~((360 / e.lines) * r + e.rotate) +
            "deg) translate(" +
            e.radius +
            "px" +
            ",0)",
          borderRadius: ((e.corners * e.width) >> 1) + "px",
        });
      }
      for (; r < e.lines; r++) {
        l = f(o(), {
          position: "absolute",
          top: 1 + ~(e.width / 2) + "px",
          transform: e.hwaccel ? "translate3d(0,0,0)" : "",
          opacity: e.opacity,
          animation:
            i &&
            s(e.opacity, e.trail, a + r * e.direction, e.lines) +
              " " +
              1 / e.speed +
              "s linear infinite",
        });
        if (e.shadow)
          n(l, f(d("#000", "0 0 4px " + "#000"), { top: 2 + "px" }));
        n(t, n(l, d(e.color, "0 0 1px rgba(0,0,0,.1)")));
      }
      return t;
    },
    opacity: function (t, e, i) {
      if (e < t.childNodes.length) t.childNodes[e].style.opacity = i;
    },
  });
  function c() {
    function t(t, e) {
      return o(
        "<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',
        e
      );
    }
    r.addRule(".spin-vml", "behavior:url(#default#VML)");
    p.prototype.lines = function (e, i) {
      var o = i.length + i.width,
        r = 2 * o;
      function s() {
        return f(
          t("group", { coordsize: r + " " + r, coordorigin: -o + " " + -o }),
          { width: r, height: r }
        );
      }
      var a = -(i.width + i.length) * 2 + "px",
        l = f(s(), { position: "absolute", top: a, left: a }),
        d;
      function u(e, r, a) {
        n(
          l,
          n(
            f(s(), { rotation: (360 / i.lines) * e + "deg", left: ~~r }),
            n(
              f(t("roundrect", { arcsize: i.corners }), {
                width: o,
                height: i.width,
                left: i.radius,
                top: -i.width >> 1,
                filter: a,
              }),
              t("fill", { color: i.color, opacity: i.opacity }),
              t("stroke", { opacity: 0 })
            )
          )
        );
      }
      if (i.shadow)
        for (d = 1; d <= i.lines; d++)
          u(
            d,
            -2,
            "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)"
          );
      for (d = 1; d <= i.lines; d++) u(d);
      return n(e, l);
    };
    p.prototype.opacity = function (t, e, i, o) {
      var n = t.firstChild;
      o = (o.shadow && o.lines) || 0;
      if (n && e + o < n.childNodes.length) {
        n = n.childNodes[e + o];
        n = n && n.firstChild;
        n = n && n.firstChild;
        if (n) n.opacity = i;
      }
    };
  }
  var h = f(o("group"), { behavior: "url(#default#VML)" });
  if (!a(h, "transform") && h.adj) c();
  else i = a(h, "animation");
  return p;
});

// Spin JS jQuery fix
/**
 * Copyright (c) 2011-2013 Felix Gnass
 * Licensed under the MIT license
 */

/*

Basic Usage:
============

$('#el').spin(); // Creates a default Spinner using the text color of #el.
$('#el').spin({ ... }); // Creates a Spinner using the provided options.

$('#el').spin(false); // Stops and removes the spinner.

Using Presets:
==============

$('#el').spin('small'); // Creates a 'small' Spinner using the text color of #el.
$('#el').spin('large', '#fff'); // Creates a 'large' white Spinner.

Adding a custom preset:
=======================

$.fn.spin.presets.flower = {
  lines: 9
  length: 10
  width: 20
  radius: 0
}

$('#el').spin('flower', 'red');

*/

(function (factory) {
  if (typeof exports == "object") {
    // CommonJS
    factory(require("jquery"), require("spin"));
  } else if (typeof define == "function" && define.amd) {
    // AMD, register as anonymous module
    define(["jquery", "spin"], factory);
  } else {
    // Browser globals
    if (!window.Spinner) throw new Error("Spin.js not present");
    factory(window.jQuery, window.Spinner);
  }
})(function ($, Spinner) {
  $.fn.spin = function (opts, color) {
    return this.each(function () {
      var $this = $(this),
        data = $this.data();

      if (data.spinner) {
        data.spinner.stop();
        delete data.spinner;
      }
      if (opts !== false) {
        opts = $.extend(
          { color: color || $this.css("color") },
          $.fn.spin.presets[opts] || opts
        );
        data.spinner = new Spinner(opts).spin(this);
      }
    });
  };

  $.fn.spin.presets = {
    tiny: { lines: 8, length: 2, width: 2, radius: 3 },
    small: { lines: 8, length: 4, width: 3, radius: 5 },
    large: { lines: 10, length: 8, width: 4, radius: 8 },
  };
});

/*! Copyright (c) 2013 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.1.3
 *
 * Requires: 1.2.2+
 */

(function (factory) {
  if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(["jquery"], factory);
  } else if (typeof exports === "object") {
    // Node/CommonJS style for Browserify
    module.exports = factory;
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  var toFix = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"];
  var toBind =
    "onwheel" in document || document.documentMode >= 9
      ? ["wheel"]
      : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"];
  var lowestDelta, lowestDeltaXY;

  if ($.event.fixHooks) {
    for (var i = toFix.length; i; ) {
      $.event.fixHooks[toFix[--i]] = $.event.mouseHooks;
    }
  }

  $.event.special.mousewheel = {
    setup: function () {
      if (this.addEventListener) {
        for (var i = toBind.length; i; ) {
          this.addEventListener(toBind[--i], handler, false);
        }
      } else {
        this.onmousewheel = handler;
      }
    },

    teardown: function () {
      if (this.removeEventListener) {
        for (var i = toBind.length; i; ) {
          this.removeEventListener(toBind[--i], handler, false);
        }
      } else {
        this.onmousewheel = null;
      }
    },
  };

  $.fn.extend({
    mousewheel: function (fn) {
      return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
    },

    unmousewheel: function (fn) {
      return this.unbind("mousewheel", fn);
    },
  });

  function handler(event) {
    var orgEvent = event || window.event,
      args = [].slice.call(arguments, 1),
      delta = 0,
      deltaX = 0,
      deltaY = 0,
      absDelta = 0,
      absDeltaXY = 0,
      fn;
    event = $.event.fix(orgEvent);
    event.type = "mousewheel";

    // Old school scrollwheel delta
    if (orgEvent.wheelDelta) {
      delta = orgEvent.wheelDelta;
    }
    if (orgEvent.detail) {
      delta = orgEvent.detail * -1;
    }

    // New school wheel delta (wheel event)
    if (orgEvent.deltaY) {
      deltaY = orgEvent.deltaY * -1;
      delta = deltaY;
    }
    if (orgEvent.deltaX) {
      deltaX = orgEvent.deltaX;
      delta = deltaX * -1;
    }

    // Webkit
    if (orgEvent.wheelDeltaY !== undefined) {
      deltaY = orgEvent.wheelDeltaY;
    }
    if (orgEvent.wheelDeltaX !== undefined) {
      deltaX = orgEvent.wheelDeltaX * -1;
    }

    // Look for lowest delta to normalize the delta values
    absDelta = Math.abs(delta);
    if (!lowestDelta || absDelta < lowestDelta) {
      lowestDelta = absDelta;
    }
    absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
    if (!lowestDeltaXY || absDeltaXY < lowestDeltaXY) {
      lowestDeltaXY = absDeltaXY;
    }

    // Get a whole value for the deltas
    fn = delta > 0 ? "floor" : "ceil";
    delta = Math[fn](delta / lowestDelta);
    deltaX = Math[fn](deltaX / lowestDeltaXY);
    deltaY = Math[fn](deltaY / lowestDeltaXY);

    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);

    return ($.event.dispatch || $.event.handle).apply(this, args);
  }
});

/* Anticroll plugin
================================ */

(function ($) {
  /**
   * Augment jQuery prototype.
   */

  $.fn.antiscroll = function (options) {
    return this.each(function () {
      if ($(this).data("antiscroll")) {
        $(this).data("antiscroll").destroy();
      }

      $(this).data("antiscroll", new $.Antiscroll(this, options));
    });
  };

  /**
   * Expose constructor.
   */

  $.Antiscroll = Antiscroll;

  /**
   * Antiscroll pane constructor.
   *
   * @param {Element|jQuery} main pane
   * @parma {Object} options
   * @api public
   */

  function Antiscroll(el, opts) {
    this.el = $(el);
    this.options = opts || {};

    this.x = false !== this.options.x || this.options.forceHorizontal;
    this.y = false !== this.options.y || this.options.forceVertical;
    this.autoHide = false !== this.options.autoHide;
    this.padding = undefined == this.options.padding ? 2 : this.options.padding;

    this.inner = this.el.find(".antiscroll-inner");
    this.inner.css({
      width: "+=" + (this.y ? scrollbarSize() : 0),
      height: "+=" + (this.x ? scrollbarSize() : 0),
    });

    this.refresh();
  }

  /**
   * refresh scrollbars
   *
   * @api public
   */

  Antiscroll.prototype.refresh = function () {
    var needHScroll =
        this.inner.get(0).scrollWidth >
        this.el.width() + (this.y ? scrollbarSize() : 0),
      needVScroll =
        this.inner.get(0).scrollHeight >
        this.el.height() + (this.x ? scrollbarSize() : 0);

    if (this.x) {
      if (!this.horizontal && needHScroll) {
        this.horizontal = new Scrollbar.Horizontal(this);
      } else if (this.horizontal && !needHScroll) {
        this.horizontal.destroy();
        this.horizontal = null;
      } else if (this.horizontal) {
        this.horizontal.update();
      }
    }

    if (this.y) {
      if (!this.vertical && needVScroll) {
        this.vertical = new Scrollbar.Vertical(this);
      } else if (this.vertical && !needVScroll) {
        this.vertical.destroy();
        this.vertical = null;
      } else if (this.vertical) {
        this.vertical.update();
      }
    }
  };

  /**
   * Cleans up.
   *
   * @return {Antiscroll} for chaining
   * @api public
   */

  Antiscroll.prototype.destroy = function () {
    if (this.horizontal) {
      this.horizontal.destroy();
      this.horizontal = null;
    }
    if (this.vertical) {
      this.vertical.destroy();
      this.vertical = null;
    }
    return this;
  };

  /**
   * Rebuild Antiscroll.
   *
   * @return {Antiscroll} for chaining
   * @api public
   */

  Antiscroll.prototype.rebuild = function () {
    this.destroy();
    this.inner.attr("style", "");
    Antiscroll.call(this, this.el, this.options);
    return this;
  };

  /**
   * Scrollbar constructor.
   *
   * @param {Element|jQuery} element
   * @api public
   */

  function Scrollbar(pane) {
    this.pane = pane;
    this.pane.el.append(this.el);
    this.innerEl = this.pane.inner.get(0);

    this.dragging = false;
    this.enter = false;
    this.shown = false;

    // hovering
    this.pane.el.mouseenter($.proxy(this, "mouseenter"));
    this.pane.el.mouseleave($.proxy(this, "mouseleave"));

    // dragging
    this.el.mousedown($.proxy(this, "mousedown"));

    // scrolling
    this.innerPaneScrollListener = $.proxy(this, "scroll");
    this.pane.inner.scroll(this.innerPaneScrollListener);

    // wheel -optional-
    this.innerPaneMouseWheelListener = $.proxy(this, "mousewheel");
    this.pane.inner.bind("mousewheel", this.innerPaneMouseWheelListener);

    // show
    var initialDisplay = this.pane.options.initialDisplay;

    if (initialDisplay !== false) {
      this.show();
      if (this.pane.autoHide) {
        this.hiding = setTimeout(
          $.proxy(this, "hide"),
          parseInt(initialDisplay, 10) || 3000
        );
      }
    }
  }

  /**
   * Cleans up.
   *
   * @return {Scrollbar} for chaining
   * @api public
   */

  Scrollbar.prototype.destroy = function () {
    this.el.remove();
    this.pane.inner.unbind("scroll", this.innerPaneScrollListener);
    this.pane.inner.unbind("mousewheel", this.innerPaneMouseWheelListener);
    return this;
  };

  /**
   * Called upon mouseenter.
   *
   * @api private
   */

  Scrollbar.prototype.mouseenter = function () {
    this.enter = true;
    this.show();
  };

  /**
   * Called upon mouseleave.
   *
   * @api private
   */

  Scrollbar.prototype.mouseleave = function () {
    this.enter = false;

    if (!this.dragging) {
      if (this.pane.autoHide) {
        this.hide();
      }
    }
  };

  /**
   * Called upon wrap scroll.
   *
   * @api private
   */

  Scrollbar.prototype.scroll = function () {
    if (!this.shown) {
      this.show();
      if (!this.enter && !this.dragging) {
        if (this.pane.autoHide) {
          this.hiding = setTimeout($.proxy(this, "hide"), 1500);
        }
      }
    }

    this.update();
  };

  /**
   * Called upon scrollbar mousedown.
   *
   * @api private
   */

  Scrollbar.prototype.mousedown = function (ev) {
    ev.preventDefault();

    this.dragging = true;

    this.startPageY = ev.pageY - parseInt(this.el.css("top"), 10);
    this.startPageX = ev.pageX - parseInt(this.el.css("left"), 10);

    // prevent crazy selections on IE
    this.el[0].ownerDocument.onselectstart = function () {
      return false;
    };

    var pane = this.pane,
      move = $.proxy(this, "mousemove"),
      self = this;

    $(this.el[0].ownerDocument)
      .mousemove(move)
      .mouseup(function () {
        self.dragging = false;
        this.onselectstart = null;

        $(this).unbind("mousemove", move);

        if (!self.enter) {
          self.hide();
        }
      });
  };

  /**
   * Show scrollbar.
   *
   * @api private
   */

  Scrollbar.prototype.show = function (duration) {
    if (!this.shown && this.update()) {
      this.el.addClass("antiscroll-scrollbar-shown");
      if (this.hiding) {
        clearTimeout(this.hiding);
        this.hiding = null;
      }
      this.shown = true;
    }
  };

  /**
   * Hide scrollbar.
   *
   * @api private
   */

  Scrollbar.prototype.hide = function () {
    if (this.pane.autoHide !== false && this.shown) {
      // check for dragging
      this.el.removeClass("antiscroll-scrollbar-shown");
      this.shown = false;
    }
  };

  /**
   * Horizontal scrollbar constructor
   *
   * @api private
   */

  Scrollbar.Horizontal = function (pane) {
    this.el = $(
      '<div class="antiscroll-scrollbar antiscroll-scrollbar-horizontal">',
      pane.el
    );
    Scrollbar.call(this, pane);
  };

  /**
   * Inherits from Scrollbar.
   */

  inherits(Scrollbar.Horizontal, Scrollbar);

  /**
   * Updates size/position of scrollbar.
   *
   * @api private
   */

  Scrollbar.Horizontal.prototype.update = function () {
    var paneWidth = this.pane.el.width(),
      trackWidth = paneWidth - this.pane.padding * 2,
      innerEl = this.pane.inner.get(0);

    this.el
      .css("width", (trackWidth * paneWidth) / innerEl.scrollWidth)
      .css("left", (trackWidth * innerEl.scrollLeft) / innerEl.scrollWidth);

    return paneWidth < innerEl.scrollWidth;
  };

  /**
   * Called upon drag.
   *
   * @api private
   */

  Scrollbar.Horizontal.prototype.mousemove = function (ev) {
    var trackWidth = this.pane.el.width() - this.pane.padding * 2,
      pos = ev.pageX - this.startPageX,
      barWidth = this.el.width(),
      innerEl = this.pane.inner.get(0);

    // minimum top is 0, maximum is the track height
    var y = Math.min(Math.max(pos, 0), trackWidth - barWidth);

    innerEl.scrollLeft =
      ((innerEl.scrollWidth - this.pane.el.width()) * y) /
      (trackWidth - barWidth);
  };

  /**
   * Called upon container mousewheel.
   *
   * @api private
   */

  Scrollbar.Horizontal.prototype.mousewheel = function (ev, delta, x, y) {
    if (
      (x < 0 && 0 == this.pane.inner.get(0).scrollLeft) ||
      (x > 0 &&
        this.innerEl.scrollLeft + Math.ceil(this.pane.el.width()) ==
          this.innerEl.scrollWidth)
    ) {
      ev.preventDefault();
      return false;
    }
  };

  /**
   * Vertical scrollbar constructor
   *
   * @api private
   */

  Scrollbar.Vertical = function (pane) {
    this.el = $(
      '<div class="antiscroll-scrollbar antiscroll-scrollbar-vertical">',
      pane.el
    );
    Scrollbar.call(this, pane);
  };

  /**
   * Inherits from Scrollbar.
   */

  inherits(Scrollbar.Vertical, Scrollbar);

  /**
   * Updates size/position of scrollbar.
   *
   * @api private
   */

  Scrollbar.Vertical.prototype.update = function () {
    var paneHeight = this.pane.el.height(),
      trackHeight = paneHeight - this.pane.padding * 2,
      innerEl = this.innerEl;

    var scrollbarHeight = (trackHeight * paneHeight) / innerEl.scrollHeight;
    scrollbarHeight = scrollbarHeight < 20 ? 20 : scrollbarHeight;

    var topPos = (trackHeight * innerEl.scrollTop) / innerEl.scrollHeight;

    if (topPos + scrollbarHeight > trackHeight) {
      var diff = topPos + scrollbarHeight - trackHeight;
      topPos = topPos - diff - 3;
    }

    this.el.css("height", scrollbarHeight).css("top", topPos);

    return paneHeight < innerEl.scrollHeight;
  };

  /**
   * Called upon drag.
   *
   * @api private
   */

  Scrollbar.Vertical.prototype.mousemove = function (ev) {
    var paneHeight = this.pane.el.height(),
      trackHeight = paneHeight - this.pane.padding * 2,
      pos = ev.pageY - this.startPageY,
      barHeight = this.el.height(),
      innerEl = this.innerEl;

    // minimum top is 0, maximum is the track height
    var y = Math.min(Math.max(pos, 0), trackHeight - barHeight);

    innerEl.scrollTop =
      ((innerEl.scrollHeight - paneHeight) * y) / (trackHeight - barHeight);
  };

  /**
   * Called upon container mousewheel.
   *
   * @api private
   */

  Scrollbar.Vertical.prototype.mousewheel = function (ev, delta, x, y) {
    if (
      (y > 0 && 0 == this.innerEl.scrollTop) ||
      (y < 0 &&
        this.innerEl.scrollTop + Math.ceil(this.pane.el.height()) ==
          this.innerEl.scrollHeight)
    ) {
      ev.preventDefault();
      return false;
    }
  };

  /**
   * Cross-browser inheritance.
   *
   * @param {Function} constructor
   * @param {Function} constructor we inherit from
   * @api private
   */

  function inherits(ctorA, ctorB) {
    function f() {}
    f.prototype = ctorB.prototype;
    ctorA.prototype = new f();
  }

  /**
   * Scrollbar size detection.
   */

  var size;

  function scrollbarSize() {
    if (size === undefined) {
      var div = $(
        '<div class="antiscroll-inner" style="width:50px;height:50px;overflow-y:scroll;' +
          'position:absolute;top:-200px;left:-200px;"><div style="height:100px;width:100%">' +
          "</div>"
      );

      $("body").append(div);
      var w1 = $(div).innerWidth();
      var w2 = $("div", div).innerWidth();
      $(div).remove();

      size = w1 - w2;
    }

    return size;
  }
})(jQuery);

/*!
 * Mobile Table
 *
 * Copyright 2013, Gray Gilmore - http://blog.graygilmore.com
 * Released under the WTFPL license - http://sam.zoy.org/wtfpl/
 *
 */

(function ($) {
  $.fn.mobileTable = function (options) {
    var settings = {
      breakpoint: 720,
    };

    if (options) {
      $.extend(settings, options);
    }

    return this.each(function () {
      var table = $(this);

      if (window.innerWidth < settings.breakpoint) {
        if (table.hasClass("titles-ready")) {
          table.addClass("mobile-layout");
          return;
        }

        table.addClass("mobile-layout titles-ready");

        table.find("thead th").each(function (i) {
          var columnTitle = $(this).text();
          table
            .find("tr td:nth-child(" + (i + 1) + ")")
            .prepend('<span class="column-title">' + columnTitle + "</span>");
        });
      } else {
        table.removeClass("mobile-layout");
      }
    });
  };
})(jQuery);
